export var SEPARATOR_TYPES;
(function (SEPARATOR_TYPES) {
    SEPARATOR_TYPES["line"] = "line";
    SEPARATOR_TYPES["space"] = "space";
})(SEPARATOR_TYPES || (SEPARATOR_TYPES = {}));
export var propsToNotForward = ['type'];
